import React from "react";
import { Button, Col } from "antd";
import { PuffLoader } from 'react-spinners';
import * as XLSX from "xlsx";

function BtnExcel({
  size,
  isClicked,
  label,
  excelData,
  xlsxHeaders,
  fileName,
  handleData,
}) {
  async function handleExport() {
    let rows = excelData;

    if (typeof handleData === "function") {
      const result = await handleData();

      if (Array.isArray(result)) {
        rows = result;
      } else if (result && Array.isArray(result.rows)) {
        rows = result.rows;
      } else if (result && result.ok === false) {
        return;
      }
    }

    if (!Array.isArray(rows) || rows.length === 0) return;

    /* generate worksheet and workbook */
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
    XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" });
    XLSX.writeFile(workbook, fileName, { compression: true });
  }

  return (
    <Col className="p-1">
      {isClicked ? (
        <Button className="px-2 py-1 mtn-1" size={size}>
           <PuffLoader color="white" size={20} />
        </Button>
      ) : (
        <Button className="px-2 py-1 mtn-1" size={size} onClick={handleExport}>
          {label}
        </Button>
      )}
    </Col>
  );
}

export default BtnExcel;
